import { FormControl, InputLabel, Select, TextField } from "@mui/material";

export default function FormTextField({
  field,
  form,
  errors,
  refs,
  label,
  onChange,
  onKeyDown,
  type = "text",
  select = false,
  children,
  SelectProps = {},
}: any) {
  const isMultiple = SelectProps.multiple === true;

  if (select && isMultiple) {
    return (
      <FormControl fullWidth error={Boolean(errors[field])}>
        <InputLabel>{label}</InputLabel>
        <Select
          label={label}
          inputRef={refs[field]}
          value={form[field] ?? []}
          onChange={onChange}
          onKeyDown={onKeyDown}
          multiple
          renderValue={SelectProps.renderValue}
        >
          {children}
        </Select>
      </FormControl>
    );
  }

  return (
    <TextField
      label={label}
      fullWidth
      select={select}
      type={type}
      inputRef={refs[field]}
      value={form[field]}
      error={Boolean(errors[field])}
      helperText={errors[field]}
      onChange={onChange}
      onKeyDown={onKeyDown}
      SelectProps={SelectProps}
    >
      {children}
    </TextField>
  );
}
